<template>
    <div class="">
        <info-modal
            ref="infoModal"
            @ok-submit="closeWindow"
            :msg="infoMsg"
        />

        <liff-error-modal
            ref="errorModal"
            @ok-submit="closeWindow"
            :msg="errorMsg"
        />

        <check-in-by-location
            @submit="submit"
            @errorModal="errorModal"
            :lineId="lineId"
            isUploadFile
            :header="$vuetify.lang.t('$vuetify.checkinOnsite.checkinOnsite')"
            ref="checkInByLocation"
        ></check-in-by-location>
    </div>
</template>
<script>
import InfoModal from '@/components/modal/InfoModal'
import LiffErrorModal from '@/components/modal/LiffErrorModal'
import CheckInByLocation from '@/components/liff/CheckInByLocation'
import axios from 'axios'

export default {
    name: 'CheckinOnSite',
    components: {
        InfoModal,
        LiffErrorModal,
        CheckInByLocation
    },

    data () {
        return {
            mode: 'view',
            infoMsg: null,
            lineId: null,
            errorMsg: '',
            textareaRule: [
                v => !!v || this.$vuetify.lang.t('$vuetify.checkinOnsite.fieldRequired')
            ]
        }
    },

    methods: {
        async getOnsiteInquiry () {
            const res = await axios.get(`${process.env.VUE_APP_BACKEND}/onsite-today?user_id=${this.lineId}`)
            this.inquiry = res.data.status
            if (res && res.data && res.data.status === 'ok') {
                try {
                    this.$refs.checkInByLocation.getLocation()
                } catch (e) {
                    this.errorModal(this.$vuetify.lang.t('$vuetify.checkinOnsite.getLocationError'))
                }
            } else {
                this.errorModal(this.$vuetify.lang.t('$vuetify.checkinOnsite.msgNoInquiry'))
            }
        },

        errorModal (message) {
            this.$store.dispatch('setLoading', false)
            this.$refs.errorModal.dialog = true
            this.errorMsg = message
        },

        async submit (submitForm) {
            const formData = {
                address: submitForm.address,
                lat: submitForm.lat,
                lon: submitForm.lon,
                img: submitForm.attachmentFile || submitForm.mapFile,
                user_id: this.lineId
            }
            this.$store.dispatch('setLoading', true)
            const res = await axios.post(`${process.env.VUE_APP_BACKEND}/onsite-today/location/create`, formData)
            if (res && res.data && res.data.status === 'ok') {
                this.$store.dispatch('setLoading', false)
                this.infoMsg = this.$vuetify.lang.t('$vuetify.checkinOnsite.msgSuccess')
                this.$refs.infoModal.dialog = true
            } else {
                this.errorModal(res.data.msg)
            }
        },

        closeWindow () {
            this.$liff.closeWindow()
        },

        errorAlert () {
            this.errorModal(this.$vuetify.lang.t('$vuetify.checkinOnsite.msgGPSError'))
        }
    },

    async mounted () {
        this.$store.dispatch('setLoading', true)
        try {
            this.lineId = await this.$util.getLineIdForLiff(process.env.VUE_APP_LINE_LOCATION_LIFF)
            // this.lineId = 'Uf935303a20903d0e21806991083691c3'
            await this.getOnsiteInquiry()
        } catch (error) {
            this.errorModal(this.$vuetify.lang.t('$vuetify.checkinOnsite.cannotGetLineId'))
        }
        this.$store.dispatch('setLoading', false)
    }
}
</script>

<style lang="scss" scoped>

</style>
